// @flow
import * as React from 'react';
import {Body, Subheading, SubheadingTextProps} from 'sail/Text';
import Box from 'sail/Box';
import {AlignBox} from 'sail/Align';
import Select, {SelectOption} from 'sail/Select';
import Group from 'sail/Group';
import Button, {ButtonGroup} from 'sail/Button';
import {TextInput} from 'sail/Input';
import {InlineLink} from 'sail/InlineLink';
import {useDiagramGenerator} from 'docs/data/diagram';

export const TYPES = ['overview', 'state', 'entity', 'sequence'];

const DESCRIPTIONS = {
  overview:
    'Overview diagrams are simple undirected graphs that show how different nodes are connected.',
  state:
    'State diagrams show how an attribute of an node changes over time or due to external actions, e.g. documenting how the status of a Stripe resource changes with API requests.',
  sequence:
    'Sequence diagrams document an end-to-end user flow or technical integration. Sequence diagrams are always auto-positioned.',
  entity:
    'Entity diagrams map out how specific entities on Stripe relate to one another.',
};

export const DiagramSelector = () => {
  const {
    type,
    setType,
    reset,
    showHandles,
    setShowHandles,
    setDescription,
  } = useDiagramGenerator();
  return (
    <Group spacing={16}>
      <Group
        direction="horizontal"
        justifyContent="space-between"
        alignItems="center"
        spacing={16}
      >
        <Group spacing={16}>
          <AlignBox reference={SubheadingTextProps}>
            <Subheading>
              <label htmlFor="diagramType">Diagram type:</label>
            </Subheading>
            <Box padding={{left: 16}}>
              <Select
                id="diagramType"
                value={type}
                onChange={(val) => {
                  setType(val);
                  reset();
                }}
              >
                {TYPES.map((t) => (
                  <SelectOption
                    key={t}
                    label={t[0].toUpperCase() + t.slice(1)}
                    value={t}
                  />
                ))}
              </Select>
            </Box>
          </AlignBox>
          <AlignBox reference={SubheadingTextProps}>
            <Subheading>
              <label htmlFor="diagramDescription">Description:</label>
            </Subheading>
            <Box padding={{left: 16}}>
              <TextInput
                id="diagramDescription"
                onChange={setDescription}
                width="long"
              />
            </Box>
          </AlignBox>
          <Box>
            <ButtonGroup>
              <Button
                label={showHandles ? 'Hide handles' : 'Show handles'}
                onClick={() => {
                  setShowHandles(!showHandles);
                }}
              />
              <Button label="Reset diagram" onClick={reset} />
            </ButtonGroup>
          </Box>
        </Group>
        <Box>
          <Body>{DESCRIPTIONS[type]}</Body>{' '}
          <InlineLink href={`/docs/markdoc/tags/diagram/${type}`}>
            More docs.
          </InlineLink>
        </Box>
      </Group>
    </Group>
  );
};
